// extracted by mini-css-extract-plugin
module.exports = {"Back":"Insurance_Back__3E7Jg"};